import { Directive, inject } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { LocalizationService, MessageService } from 'abp-ng2-module';

@Directive({
  selector: '[nwAppComponentBase]'
})
export abstract class AppComponentBaseDirective {
  localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;
  localization = inject(LocalizationService);
  message = inject(MessageService);

  l(key: string, ...args: any[]): string {
    let localizedText = this.localization.localize(key, this.localizationSourceName);

    if (!localizedText) {
      localizedText = key;
    }

    if (!args || !args.length) {
      return localizedText;
    }
    return abp.utils.formatString.apply(this, [localizedText, ...args]);
  }
}
